import { graphql } from "@/gql";

export const favoritesQuery = graphql(`
  query Favorites {
    favorites {
      itemId
      type
    }
  }
`)